"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePresets = void 0;
var react_1 = require("react");
var defaultPresets = [
    { value: '50', label: '' },
    { value: '100', label: '' },
    { value: '200', label: '' },
    { value: '500', label: '' },
    { value: '1000', label: '' },
];
var usePresets = function (presetOptions) {
    return (0, react_1.useMemo)(function () {
        return (presetOptions || defaultPresets).map(function (el) { return ({
            label: "".concat(el.label || el.value),
            value: "".concat(el.value),
        }); });
    }, [presetOptions]);
};
exports.usePresets = usePresets;
